import { FormEvent, useState } from 'react'
import Button from '../Button'
import * as S from './styles'

const Conta = () => {
  const [num1, setNum1] = useState('')
  const [num2, setNum2] = useState('')
  const [num3, setNum3] = useState('')
  const [num4, setNum4] = useState('')

  const calcular = (e: FormEvent) => {
    e.preventDefault()
    const conta = ((parseInt(num3) * parseInt(num2)) / parseInt(num1)).toFixed(
      2
    )
    setNum4(conta.toString())
  }

  return (
    <>
      <S.Teste onSubmit={calcular}>
        <S.Calc>
          <S.Inputs>
            <input type="tel" onChange={(e) => setNum1(e.target.value)} />
            <span>-</span>
            <input type="tel" onChange={(e) => setNum2(e.target.value)} />
          </S.Inputs>
          <S.Inputs>
            <input type="tel" onChange={(e) => setNum3(e.target.value)} />
            <span>-</span>
            <input className="resultado" type="tel" value={num4} />
          </S.Inputs>
        </S.Calc>
        <Button>Calcular</Button>
      </S.Teste>
    </>
  )
}

export default Conta
